"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function autobind(_target, name, descriptor) {
    var enumerable = descriptor.enumerable, configurable = descriptor.configurable, value = descriptor.value;
    var boundMethod = Symbol("boundMethod." + name);
    return {
        enumerable: enumerable,
        configurable: configurable,
        get: function () {
            return this[boundMethod] || (this[boundMethod] = value.bind(this));
        },
        set: function (value) {
            Object.defineProperty(this, name, {
                writable: true,
                enumerable: true,
                configurable: true,
                value: value,
            });
        },
    };
}
exports.autobind = autobind;
//# sourceMappingURL=autobind.js.map